import React, { useState, useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import { AthleteHeader } from "../common/AthleteHeader";
import API_URL from "../../api/API";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import bgImg from "../../images/runRocket.jpeg";

export const AthleteRunrocketTrainingDay = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const { week_day, day_id } = useParams();

  const [openIndex, setOpenIndex] = useState(null); // Accordion state
  const [trainingData, setTrainingData] = useState([]); // Stores fetched training sets
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [maxSpeeds, setMaxSpeeds] = useState({}); // To store max speeds for each set

  const [inputSpeeds, setInputSpeeds] = useState({});

  const [testResult, setTestResult] = useState(null);
  const [targetSpeed, setTargetSpeed] = useState(0);
  const [peakSpeed, setPeakSpeed] = useState(0);
  const [targetLoad, setTargetLoad] = useState(0);
  const [day_training_focus, setDayTrainingFocus] = useState("");

  const [videoModalOpen, setVideoModalOpen] = useState(false);
const [videoUrl, setVideoUrl] = useState("");
const [videoTitle, setVideoTitle] = useState("");

const [exerciseDetails, setExerciseDetails] = useState(null);

  const fetchTrainingData = async () => {
    try {
      const response = await fetch(
        `${API_URL.GET_RUNROCKET_TRAINING_TEMPLATE_DAY_SETS}${day_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch training data");
      }

      const data = await response.json();
      setDayTrainingFocus(data.training_focus);
      console.log(data);
      setTrainingData(data.sets || []); // Set data, fallback to empty array

      if (data.exerciseDetails) {
        setExerciseDetails(data.exerciseDetails);
      }

      // Step 2: Fetch max speeds for each set if they exist
      const maxSpeedsResponse = await fetch(
        `${API_URL.GET_ATHLETE_RUNROCKET_TRAINING_DAY_MAXSPEEDS}${day_id}/${athlete.id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        },
      );

      if (maxSpeedsResponse.ok) {
        const maxSpeedData = await maxSpeedsResponse.json();

        // Ensure maxSpeedData.data is an array
        if (Array.isArray(maxSpeedData.data)) {
          const maxSpeedsObj = {};

          // Process each set and store maxspeed by set_id
          maxSpeedData.data.forEach((set) => {
            maxSpeedsObj[set.set_id] = set.maxspeed; // Store maxspeed per set_id
          });

          // Update the state with maxspeed values
          setMaxSpeeds(maxSpeedsObj);
        } else {
          console.warn("maxSpeedData.data is not an array:", maxSpeedData.data);
        }
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTestResults = async () => {
    try {
      const response = await fetch(
        API_URL.GET_ATHLETE_RUNROCKET_TEST_RESULT + athlete.id,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch test results");
      }

      const data = await response.json();
      setTestResult(data.data);
      console.log(data.data);
      //build logic here such that based on the training focus for that day,
      //determine the target speed and target load to use.

      if (day_training_focus === "Technical") {
        setTargetLoad(data.data.target_load_technical);
        setTargetSpeed(data.data.target_speed_technical);
      } else if (day_training_focus === "Speed - Strength") {
        setTargetLoad(data.data.target_load_speedstrength);
        setTargetSpeed(data.data.target_speed_speedstrength);
      } else if (day_training_focus === "Power") {
        setTargetLoad(data.data.target_load_power);
        setTargetSpeed(data.data.target_speed_power);
      } else if (day_training_focus === "Strength - Speed") {
        setTargetLoad(data.data.target_load_strengthspeed);
        setTargetSpeed(data.data.target_speed_strengthspeed);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Fetch training sets for the specific day
  useEffect(() => {
    fetchTrainingData();
    // fetchTestResults();
  }, [day_id, athlete.token]);

  // Fetch training sets for the specific day
  useEffect(() => {
    // fetchTrainingData();
    fetchTestResults();
  }, [day_training_focus, day_id, athlete.token]);

  // Toggle accordion logic for each index
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Handle the "plus" button click to save maxspeed OLD
  /*const handleSaveMaxSpeed = async (set_id) => {
    const maxSpeed = maxSpeeds[set_id]; // Get the maxspeed from state
    if (!maxSpeed) {
      alert("Please enter a max speed value.");
      return;
    }

    try {
      const response = await fetch(
        `${API_URL.POST_ATHLETE_RUNROCKET_TRAINING_DAY_SET_MAXSPEED}${set_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${athlete.token}`,
          },
          body: JSON.stringify({
            maxspeed: parseFloat(maxSpeed), // Convert to float
            athlete_id: athlete.id, // Pass the athlete_id
            day_id: day_id, // Pass the day_id
            set_id: set_id, // Pass the set_id
            week_day: week_day,
            day_training_focus: day_training_focus,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to save maxspeed.");
      }

      const data = await response.json();
      console.log("Maxspeed saved:", data);

      // Update UI to show that maxspeed was saved (Optional)
      alert("Maxspeed saved successfully!");
    } catch (error) {
      console.error("Error saving maxspeed:", error);
      alert("Error saving maxspeed.");
    }
  };*/

  // Handle change in maxspeed input OLD
  /*const handleMaxSpeedChange = (e, set_id) => {
    const value = e.target.value;
    setMaxSpeeds((prev) => ({
      ...prev,
      [set_id]: value, // Update the maxspeed value for the specific set
    }));
  };*/

  const handleSaveMaxSpeed = async (set_id) => {
    const maxSpeed = inputSpeeds[set_id];
    if (!maxSpeed) {
      alert("Please enter a max speed value.");
      return;
    }
  
    try {
      const response = await fetch(
        `${API_URL.POST_ATHLETE_RUNROCKET_TRAINING_DAY_SET_MAXSPEED}${set_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${athlete.token}`,
          },
          body: JSON.stringify({
            maxspeed: parseFloat(maxSpeed),
            athlete_id: athlete.id,
            day_id: day_id,
            set_id: set_id,
            week_day: week_day,
            day_training_focus: day_training_focus,
          }),
        },
      );
  
      if (!response.ok) throw new Error("Failed to save maxspeed.");
  
      const data = await response.json();
      console.log("Maxspeed saved:", data);
  
      // Save to maxSpeeds so it shows as placeholder, clear the input
      setMaxSpeeds((prev) => ({ ...prev, [set_id]: maxSpeed }));
      setInputSpeeds((prev) => ({ ...prev, [set_id]: "" }));
  
      alert("Maxspeed saved successfully!");
    } catch (error) {
      console.error("Error saving maxspeed:", error);
      alert("Error saving maxspeed.");
    }
  };

  const handleMaxSpeedChange = (e, set_id) => {
    const value = e.target.value;
    setInputSpeeds((prev) => ({
      ...prev,
      [set_id]: value,
    }));
  };


  const getEmbedUrl = (url) => {
    if (!url) return "";
  
    const regExp =
      /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([^?&/]+)/;
  
    const match = url.match(regExp);
  
    return match
      ? `https://www.youtube.com/embed/${match[1]}`
      : url;
  };

  return (
    <AthleteLayout>
      <div className="relative h-full bg-white pb-5 overflow-y-auto">
        <div className="w-full max-w-screen-xl mx-auto border-t border-black/30 mt-2"></div>

        {/* background image if need again */}
        {/* <div className="absolute inset-0">
          <img src={bgImg} alt="bgImg" className="object-cover w-full h-full" />
          <div className="w-full h-full absolute inset-0 bg-white/70"></div>
        </div> */}
        <div className="relative w-full max-w-2xl mx-auto px-5 py-5">
          {/* Header with Back Navigation */}
          <div className="relative bg-black text-left px-4 py-3 rounded-lg mb-8">
            <p className="text-white text-base font-medium pl-5 capitalize">
              {week_day}
            </p>
            <Link to="/athlete/tools/runrocket/training-weeks">
              <button
                onClick={() => navigate(-1)}
                className="absolute left-3 top-1/2 -translate-y-1/2"
              >
                <ArrowL />
              </button>
            </Link>
          </div>

          {/* Circular Progress Indicator */}
          <div className="pt-8 pb-14 relative mx-auto">
            <div
              style={{ width: 174, height: 174 }}
              className="mx-auto relative"
            >
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={(targetSpeed * 100) / 10}
                styles={buildStyles({
                  pathColor: "#c19e42", // Progress path color
                  trailColor: "#000", // Background path color
                })}
              >
                <p className="text-black text-5xl medium mb-2">{targetSpeed}</p>
                <span className="text-[#A5A5A5] text-[12px] medium leading-[91%] uppercase">
                  Target Speed
                </span>
              </CircularProgressbarWithChildren>

          
            </div>



                    {/* Centered Training Focus Text */}
              <p className="text-black text-lg font-semibold mt-3 text-center w-full">
                {day_training_focus}
              </p>
    

            {exerciseDetails && (
                <div className="mt-4 text-center">
                  <p className="text-black text-sm font-medium">
                    {exerciseDetails.title}
                  </p>

                  {exerciseDetails.video_url && (
                    <button
                      onClick={() => {
                        setVideoUrl(exerciseDetails.video_url);
                        setVideoTitle(exerciseDetails.title);
                        setVideoModalOpen(true);
                      }}
                      className="mt-2 text-xs text-blue-600 underline"
                    >
                      ▶ Play Video
                    </button>
                  )}
                </div>
              )}
          </div>

          {/* label header */}
          <div className="bg-black rounded-xl py-3 px-3 divide-x-2 divide-white/50 flex flex-row justify-between items-stretch text-center relative mt-5 z-10">
            <div className="w-[30%] px-2">
              <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercase">
                REPS
              </p>
            </div>
            <div className="w-[30%] px-2">
              <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercase">
                Distance
              </p>
            </div>
            <div className="w-[30%] px-2">
              <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercase">
                LOAD
              </p>
            </div>
            <div className="w-[10%] opacity-0"></div>
          </div>

          {/* Loading & Error Handling */}
          {isLoading ? (
            <p className="text-center text-gray-600 pt-3">
              Loading training data...
            </p>
          ) : error ? (
            <p className="text-center text-red-500 pt-2">{error}</p>
          ) : (
            <div className="my-5 space-y-5">
              {trainingData.length === 0 ? (
                <p className="text-center text-gray-500">No sets available.</p>
              ) : (
                trainingData.map((item, index) => (
                  <div
                    key={index}
                    className="bg-transparent py-3 px-3 rounded-xl border border-black/30 bg-white"
                  >
                    {/* Row with Clickable Area */}
                    <div
                      className="flex flex-row justify-between items-stretch text-center cursor-pointer text-black"
                      onClick={() => toggleAccordion(index)}
                    >
                      <div className="max-xs:h-auto w-[30%] flex justify-center items-center px-1 border-r border-black">
                        <p className="max-xs:text-xs font-light">{item.reps}</p>
                      </div>
                      <div className="max-xs:h-auto w-[30%] flex justify-center items-center px-1 border-r border-black">
                        <p className="max-xs:text-xs font-light">
                          {item.distance}
                        </p>
                      </div>
                      <div className="max-xs:h-auto w-[30%] flex justify-center items-center px-1">
                        <p className="max-xs:text-xs font-light">
                          {targetLoad}
                        </p>
                      </div>
                      <div className="h-fit w-[10%] flex justify-end items-center">
                        <span className={`transform transition-transform w-5 h-5`}>
                          {openIndex === index ? (
                            <>
                              <Minus />
                            </>
                          ) : (
                            <>
                              <Plus />
                            </>
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Expanded Section (Shown When Clicked) */}
                    {openIndex === index && (
                      <div className="flex flex-col gap-3 py-3 mt-3 border-t-2 border-darkYellow">
                        <div className="relative w-full border-b border-black mx-auto">
                          <span className="uppercase text-[#a5a5a5] text-xs font-medium text-start mx-auto">
                            Actual Speed
                          </span>
                          <div className="relative">
                            {/*<input
                              type="text"
                              placeholder="Your max speed"
                              value={maxSpeeds[item._id] || ""}
                              onChange={(e) =>
                                handleMaxSpeedChange(e, item._id)
                              } // Update state on change
                              className="placeholder:text-[#5D5D5D] placeholder:font-medium text-black text-base font-light bg-transparent w-full outline-none p-2 pr-12"
                            />*/}

                            <input
                              type="text"
                              placeholder={maxSpeeds[item._id] ? `Last saved: ${maxSpeeds[item._id]}` : "Your max speed"}
                              value={inputSpeeds[item._id] || ""}
                              onChange={(e) => handleMaxSpeedChange(e, item._id)}
                              className="placeholder:text-[#5D5D5D] placeholder:font-medium text-black text-base font-light bg-transparent w-full outline-none p-2 pr-12"
                            />

                            <span
                              className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer rounded-full size-8 flex justify-center items-center bg-grayish/50 hover:bg-darkYellow transition group"
                              onClick={() => handleSaveMaxSpeed(item._id)} // Save maxspeed on click
                            >
                              <Add />
                            </span>
                          </div>
                        </div>
                        <p className="text-black text-xs font-medium whitespace-pre-wrap break-words">
                          {item.rest ? item.rest : "No rest details available."}
                        </p>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      {videoModalOpen && (
  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg w-[90%] max-w-xl p-4 relative">
      
      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-black text-lg"
        onClick={() => setVideoModalOpen(false)}
      >
        ✕
      </button>

      {/* Title */}
      <p className="text-black font-semibold mb-3">
        {videoTitle}
      </p>

      {/* Video */}
      <div className="w-full aspect-video">
        <iframe
          src={getEmbedUrl(videoUrl)}
          title="Exercise Video"
          className="w-full h-full rounded"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  </div>
)}
    </AthleteLayout>

    
  );
};

// SVG Icons
const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowL = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M7 13L1 7L7 1"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Add = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 21 22"
    fill="none"
  >
    <path
      d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Plus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      <path d="M11 4.5H13V19.5H11V4.5Z" fill="black" />
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

const Minus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      {/* <path d="M10.5 4H13.5V20H10.5V4Z" fill="black" /> */}
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};
